module.exports = "https://la-static.vkplay.ru/promo/newstart/img/aeromancer.39cfef80.png";